export const RESOLVE_STATUS = {
    CLOSE: 'close',
    APPLY: 'apply',
} as const;

export const DIALOG_STATUS = {
    LOADING: 'loading',
    SUCCESS: 'success',
    FAILED: 'failed',
} as const;
